<template>
	<div>
		<q-table
			ref="table"
			:data="data"
			:columns="columns"
			row-key="id"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5,10,50,100]"
			binary-state-sort
			class="q-mt-lg"
			>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
				{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
                    <q-td key="drill_id" :props="props">
						{{ props.row.drill_id }}
					</q-td>

					<q-td key="drill_title" :props="props">
						{{ props.row.drill_title }}
					</q-td>

					<q-td key="score" :props="props">
						{{ props.row.score.toFixed(2) }}
					</q-td>

					<q-td key="result_date" :props="props">
						{{ getDateFormated(props.row.result_date) }}
					</q-td>

                    <q-td key="status" :props="props" auto-width >
                        <q-chip small :color="getColorStatus(props.row.status)" >
                            {{ $t(getStatus(props.row.status)) }}
                        </q-chip>
                    </q-td>

                    <q-td key="published" :props="props" auto-width >
                        <q-chip small :color="getColorDrillStatus(props.row.drill_status)" >
                            {{ $t(getDrillStatus(props.row.drill_status)) }}
                        </q-chip>
                    </q-td>
				</q-tr>
			</template>
		</q-table>

		<certificate :show="show_certificate" :data="certificate_data" @hideCertificate="hideCertificate" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import Certificate from 'components/Certificate'

export default {
    name: 'UserReportCourseResultsTab',

	components: {
        'certificate': Certificate
    },

    data() {
        return {
			loading: false,
			certificate_data: [],
			show_certificate: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'drill_id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'drill_id',
                    sortable: false,
                },
                {
                    name: 'drill_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'drill_title',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'result_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'result_date',
                    sortable: false,
				},
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
                {
                    name: 'published',
                    required: true,
                    label: 'published',
                    align: 'left',
                    field: 'published',
                    sortable: false,
                },
            ],
            data: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

		getHeaderUrlencoded() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_drill_user_results/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.data = []

                response.data.results.forEach(result => {
                    this.data.push(result)
                })
                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        getDateFormated(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
		},

		hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        getStatus(status) {
            if (status == 1) return 'aproved'
            else if (status == 2) return 'reproved'
            else if (status == 3) return 'restarted'
            else return ''
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'negative'
            else if (status == 3) return 'warning'
            else return ''
        },

        getDrillStatus(status) {
            if (status == 1) return 'published'
            else if (status == 2) return 'unpublished'
            else if (status == 3) return 'deleted'
            else return ''
        },

        getColorDrillStatus(status) {
            if (status == 1) return 'positive'
            else if (status >= 2) return 'negative'
            else return ''
        },
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

		this.request({ pagination: this.server_pagination })
	}
}
</script>

<style>

</style>
